<template>
  <ocr-recognition :source="INTELLIGENT_DOCUMENT_SOURCE_13.code" />
</template>

<script>
import ocrRecognition from '@/views/cargo/v0/ToolAssistant/ocrRecognition'
import {
  INTELLIGENT_DOCUMENT_SOURCE_13
} from '@/class/cargo/model/parameters/SystemConstants'
export default {
  name: 'OcrRecognitionAI',
  components: { ocrRecognition },
  data() {
    return {
      INTELLIGENT_DOCUMENT_SOURCE_13
    }
  }
}
</script>

<style scoped>

</style>
